import React from "react";
import { Pencil, Trash2, Lock } from "lucide-react";
import { TRY, trDate, weekendRow } from "@/lib/api";
import { Card } from "@/components/Cards";

const SRC = { manual: "Elle", ledger: "Tahsilat", staff: "Personel", cost: "Maliyet" };

export default function CashEntriesTable({ rows, onEdit, onDelete }) {
  return (
    <Card className="overflow-hidden" data-testid="cashbook-table">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-border bg-muted/40 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            <th className="px-4 py-3">Tarih</th><th className="px-4 py-3">Açıklama</th><th className="px-4 py-3">Grup</th><th className="px-4 py-3">Hesap</th><th className="px-4 py-3 text-right">Gelir</th><th className="px-4 py-3 text-right">Gider</th><th className="px-4 py-3 w-24"></th>
          </tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-muted-foreground" data-testid="cashbook-empty">Bu dönemde kayıt yok — "Kayıt Ekle" ile başlayın</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className={"border-b border-border/60 hover:bg-accent/40" + weekendRow(r.date)} data-testid={`cash-row-${r.id}`}>
                <td className="px-4 py-2.5 font-mono text-xs whitespace-nowrap">{trDate(r.date)}</td>
                <td className="px-4 py-2.5"><div className="font-medium">{r.description}</div>{r.note && <div className="text-xs text-muted-foreground">{r.note}</div>}</td>
                <td className="px-4 py-2.5"><span className="rounded-full bg-muted px-2.5 py-0.5 text-xs">{r.group_label}</span></td>
                <td className="px-4 py-2.5 text-xs text-muted-foreground" data-testid={`cash-account-${r.id}`}>{r.account_name || r.method || "—"}</td>
                <td className="px-4 py-2.5 text-right font-mono text-emerald-400">{r.kind === "income" ? TRY(r.amount) : ""}</td>
                <td className="px-4 py-2.5 text-right font-mono text-rose-400">{r.kind === "expense" ? TRY(r.amount) : r.kind === "transfer" ? <span className="text-sky-400" title="Virman">⇄ {TRY(r.amount)}</span> : ""}</td>
                <td className="px-4 py-2.5">
                  {r.editable ? (
                    <div className="flex justify-end gap-1">
                      <button onClick={() => onEdit(r)} data-testid={`cash-edit-${r.id}`} className="h-7 w-7 rounded-md hover:bg-accent inline-flex items-center justify-center text-muted-foreground"><Pencil className="h-3.5 w-3.5" /></button>
                      <button onClick={() => onDelete(r.id)} data-testid={`cash-delete-${r.id}`} className="h-7 w-7 rounded-md hover:bg-destructive/10 inline-flex items-center justify-center text-muted-foreground hover:text-destructive"><Trash2 className="h-3.5 w-3.5" /></button>
                    </div>
                  ) : <span className="flex items-center justify-end gap-1 text-[10px] uppercase tracking-wider text-muted-foreground" title="Otomatik kayıt — kaynağından düzenlenir"><Lock className="h-3 w-3" /> {SRC[r.source]}</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
